import React, {createContext, useContext} from 'react'
import {UseQueryResult} from 'react-query'
import {ProfilePage} from './core/_models'

type ProfilePageContextValue = Pick<
  UseQueryResult<ProfilePage | undefined>,
  'data' | 'isLoading' | 'isFetching' | 'refetch' | 'error'
>

const ProfilePageContext = createContext<ProfilePageContextValue | null>(null)

export const ProfilePageProvider: React.FC<
  React.PropsWithChildren<{value: ProfilePageContextValue}>
> = ({value, children}) => (
  <ProfilePageContext.Provider value={value}>{children}</ProfilePageContext.Provider>
)

export const useProfilePageQuery = (): ProfilePageContextValue => {
  const ctx = useContext(ProfilePageContext)
  if (!ctx) {
    throw new Error('useProfilePageQuery must be used within ProfilePageProvider')
  }
  return ctx
}
